import React, { useEffect, useMemo, useState, useRef, useCallback } from "react";
import { Col, Row, Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { useMediaQuery } from 'react-responsive';
import { APISD } from "../../../../../../../config/apisd";
import { APIMS } from "../../../../../../../config/apims";
import "bulma/css/bulma.css";
import "../../../../../../../index.css";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardUser } from '@fortawesome/free-solid-svg-icons';
import ToastError from "../../../../../../NotificationToast/ToastError";
import { PulseLoader } from "react-spinners";
import swal from "sweetalert";

/* ===========================
   🔥 CSS
=========================== */
const css = `
  @keyframes shimmer {
    0% { background-position: -468px 0; }
    100% { background-position: 468px 0; }
  }
  .shimmer {
    animation-duration: 1.2s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-name: shimmer;
    background: #f6f7f8;
    background: linear-gradient(
      to right,
      #ddeaffff 8%,
      #f4f8ffff 18%,
      #ddeaffff 33%
    );
    background-size: 800px 104px;
  }
  .shimmer-select {
    height: 35px;
    border-radius: 4px;
  }
  .shimmer-row {
    height: 38px;
  }

  .at-panel{
    margin-top: 14px;
    background:#fff;
    border:1px solid #e7eaf0;
    overflow: hidden;
  }

  .at-table-wrap{ overflow:auto; }

  .at-table{
    width:100%;
    border-collapse: collapse;
  }

  .at-table thead th{
    text-align:left;
    font-size: 14px;
    color:#3f51b5;
    font-weight: 700;
    padding: 12px 14px;
    border-bottom:1px solid #e9edf5;
    white-space: nowrap;
    background: #fff;
  }

  .at-table tbody td{
    padding: 12px 14px;
    border-bottom:1px solid #edf1f7;
    font-size: 14px;
    color:#0f172a;
    vertical-align: middle;
  }

  .at-center { text-align: center !important; }

  .at-select{
    width:100%;
    height: 40px;
    border:1px solid #cfd8e6;
    border-radius: 0;
    padding: 0 10px;
    font-size: 14px;
    color: #334155;
    background: #fff;
    outline: none;
  }

  .at-select:disabled{
    background: #f8fafc;
    color: #94a3b8;
    cursor: not-allowed;
  }

  .at-select option[disabled]{
    color: #94a3b8;
  }
`;

export default function LogAbsensi() {
  document.title = "Log Absensi";

  const [page] = useState(1);
  const [limit] = useState(1000);
  const [ascending] = useState(1);
  const ascdng = 0;
  const [descending] = useState(0);
  const [keyword] = useState("");
  const token = localStorage.getItem("token");
    
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 780px)" });
  const [loading, setLoading] = useState(false);
  const [loadingSchool, setLoadingSchool] = useState(false);

  const firstLoadDone = useRef(false);
  const initSchoolDone = useRef(false);
  const initLevelDone = useRef(false);
  const initKelasDone = useRef(false);

  const storageBranchGroping = localStorage.getItem("ysb_branch_id");
  const storageLevel = localStorage.getItem("level");

  const id_user = localStorage.getItem("id_admin") || "";
  const output_id_user = id_user.replace(/[|&;$%@"<>()+,]/g, "");
    
  // Data master
  const [getDataSemesterMap, setGetDataSemesterMap] = useState([]);
  const [getDataBranch, setGetDataBranch] = useState([]);
  const [getDataSchool, setGetDataSchool] = useState([]);
    
  // Tingkatan & Kelas
  const [getDataLevel, setGetDataLevel] = useState([]);
  const [getDataKelas, setGetDataKelas] = useState([]);
  const [loadingLevel, setLoadingLevel] = useState(false);
  const [loadingKelas, setLoadingKelas] = useState(false);
    
    
  // Table data
  const [getData, setGetData] = useState([]);

  // Search frontend
  const [searchKeyword, setSearchKeyword] = useState("");

  // Pagination frontend
  const [tablePage, setTablePage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // UI state
  const [hasSearched, setHasSearched] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [isFilterDirty, setIsFilterDirty] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  
  const [namaTA, setNamaTA] = useState("");
  const [namaSmstr, setNamaSmstr] = useState("");

  // Filter form
  const [form2, setForm2] = useState({
    ysb_semester_id: "",
    ysb_branch_id: "",
    ysb_school_id: "",
    ysb_grade_level_id:"",
    ysb_kelas_id:"",
  });

  // Filter permission menu
  const location = useLocation();
  const [permission, setPermission] = useState({
    create: 0,
    read: 0,
    update: 0,
    delete: 0
  });

  const navigate = useNavigate();
  useEffect(() => {
    const storageLevel = localStorage.getItem('level');
    const storageItems = JSON.parse(localStorage.getItem('role_permission')) || [];
    if (storageLevel === "developer" || storageLevel === "superadmin") {
      setPermission({
        create: 1,
        read: 1,
        update: 1,
        delete: 1
      });
    } else {
      const foundPermission = storageItems.find(item => item.menu?.url === location.pathname);
      if (!foundPermission) { 
        navigate('/dashboard');
      } else {
        setPermission({
          create: foundPermission.create,
          read: foundPermission.read,
          update: foundPermission.update,
          delete: foundPermission.delete
        });
      }}
  }, [location.pathname]);

  /* API HEADERS */
  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  // ---------- helper refs ----------
    const isMounted = useRef(true);
    const abortControllers = useRef([]);
    
    useEffect(() => {
      return () => {
        isMounted.current = false;
        abortControllers.current.forEach((c) => c.abort());
      };
    }, []);
    
    const collator = useMemo(() => new Intl.Collator("id", { numeric: true, sensitivity: "base" }), []);
      
    const safeStr = (v) => (v === null || v === undefined ? "" : String(v));
    
    // SORT sekolah
    const sortSchools = (schools) => {
      const order = ["SD", "SMP", "SMA"];
      return [...schools].sort((a, b) => {
        const jenjangA = order.findIndex((j) => (a.school_name || "").toUpperCase().includes(j));
        const jenjangB = order.findIndex((j) => (b.school_name || "").toUpperCase().includes(j));
        return jenjangA - jenjangB;
      });
    };

    const removeBasementBekasi = (schools, branchId) => {
      if (branchId === "BKS") return schools.filter((s) => s.school_code !== "BASEMENT_BEKASI");
      return schools;
    };


    const fetchCabang = async () => {
      setLoading(true);
        const response = await APIMS.get(
            `/api/access/branches?page=1&limit=1000&ascending=${ascending}&branch=${storageBranchGroping}&search=`,
            fetchParams
        );

        // Branch default pertama
        if (response?.status === 200) {
          const branches = response.data.data || [];
          setGetDataBranch(branches);
          if (branches.length > 0) {
            const firstBranch = branches[0].branch_code;
            setForm2((prev) => ({ ...prev, ysb_branch_id: firstBranch }));
          }
        }
    } 

    useEffect(() => {
        fetchCabang();
    }, [])

    const fetchSemester = async () => {
       setLoading(true);

        const response = await APIMS.get(
            `/api/access/semesters?page=1&limit=1000&ascending=${ascending}&search=`,
            fetchParams
        );

        // Semester aktif
        if (response?.status === 200) {
          const semesters = response.data.data || [];
          const active = semesters.find((s) => s.status === 1) || semesters[0];
          setGetDataSemesterMap(semesters);
          if (active) {
            setNamaTA(active.name_year || "");
            setNamaSmstr(active.semester || "");
            setForm2((prev) => ({ ...prev, ysb_semester_id: active.id }));
          }
        }
    } 

    useEffect(() => {
        fetchSemester();
    }, [])

    const fetchSchoolsByBranch = useCallback(
      async (branchId) => {
        initSchoolDone.current = false;
        initLevelDone.current = false;
        initKelasDone.current = false;
        setLoadingSchool(true); 
        try {
          const res = await APIMS.get(
            `/api/access/schools?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
            fetchParams
          );
          if (res?.status === 200) {
            let schools = res.data.data || [];

            if (storageLevel === "developer" || storageLevel === "superadmin") {
              schools = schools.filter(
                (s) => s.ysb_branch_id === branchId
              );
            }

            schools = removeBasementBekasi(schools, branchId);
            schools = sortSchools(schools);

            setGetDataSchool(schools);

            // default sekolah pertama
            if (schools.length > 0) {
              // reset dependensi saat sekolah berubah (tingkatan/kelas)
              setGetDataLevel([]);
              setGetDataKelas([]);
              setForm2((prev) => ({
                ...prev,
                ysb_school_id: schools[0].school_code,
              }));
            } else {
              setGetDataLevel([]);
              setGetDataKelas([]);
              setForm2((prev) => ({ ...prev, ysb_school_id: "" }));
            }
          }
        } catch (err) {
          console.log(err);
        } finally {
            initSchoolDone.current = true;
            setLoadingSchool(false); 
            setLoading(false);       
        }
      },[ascending, fetchParams, limit, page, storageLevel]
    );

    useEffect(() => {
      if (form2.ysb_branch_id) fetchSchoolsByBranch(form2.ysb_branch_id);
    }, [form2.ysb_branch_id, fetchSchoolsByBranch]);


    // =========================
    // Fetch tingkatan saat sekolah berubah
    // =========================
    // const sortLevels = (levels) => {
    //   return [...levels].sort((a, b) =>
    //     (a?.name_level || "").localeCompare((b?.name_level || ""), "id", { numeric: true, sensitivity: "base" })
    //   );
    // };

    // const sortKelas = (kelas) => {
    //   return [...kelas].sort((a, b) =>
    //     (a?.name_kelas || "").localeCompare((b?.name_kelas || ""), "id", { numeric: true, sensitivity: "base" })
    //   );
    // };

    // const fetchLevelsBySchool = useCallback(
    //   async (schoolId, branchId) => {
    //     initLevelDone.current = false;
    //     initKelasDone.current = false; 
    //     if (!schoolId) return;

    //     setLoadingLevel(true);
    //     try {
    //       const res = await APIMS.get(
    //         `/api/grade-levels?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
    //         fetchParams
    //       );

    //       if (res?.status === 200) {
    //         let levels = res.data?.data || [];

           
    //         levels = levels.filter((x) => x?.ysb_school_id === schoolId);
    //         if (branchId) levels = levels.filter((x) => x?.ysb_branch_id === branchId);

    //         levels = sortLevels(levels);
    //         setGetDataLevel(levels);

    //         if (levels.length === 0) {
    //           initKelasDone.current = true;
    //         }

    //         // default tingkatan pertama
    //         if (levels.length > 0) {
    //           setForm2((prev) => ({
    //             ...prev,
    //             ysb_grade_level_id: levels[0].id,
    //           }));
    //         } else {
    //           setForm2((prev) => ({
    //             ...prev,
    //             ysb_grade_level_id: "",
    //             ysb_kelas_id: "",
    //           }));

    //         setGetDataKelas([]);
    //         }
    //       }
    //     } catch (err) {
    //       console.error(err);
    //       swal({
    //         title: "Failed",
    //         text: err?.response?.data?.message || err.message || "Gagal mengambil data tingkatan",
    //         icon: "error",
    //         timer: 3000,
    //         buttons: false,
    //       });

    //       setGetDataLevel([]);
    //       setGetDataKelas([]);
    //       setForm2((prev) => ({ ...prev, ysb_grade_level_id: "", ysb_kelas_id: "" }));

    //     } finally {
    //       initLevelDone.current = true;
    //       setLoadingLevel(false);
    //     }
    //   }, [fetchParams]
    // );

   
    // useEffect(() => {
    //   if (!form2.ysb_school_id) {
    //     setGetDataLevel([]);
    //     setGetDataKelas([]);
    //     setForm2((prev) => ({ ...prev, ysb_grade_level_id: "", ysb_kelas_id: "" }));
    //   return;
    //   }

    //   setGetDataLevel([]);
    //   setGetDataKelas([]);
    //   setForm2((prev) => ({ ...prev, ysb_grade_level_id: "", ysb_kelas_id: "" }));
    //   fetchLevelsBySchool(form2.ysb_school_id, form2.ysb_branch_id);
    // }, [form2.ysb_school_id, form2.ysb_branch_id, fetchLevelsBySchool]);

    // =========================
    // Fetch kelas saat tingkatan berubah
    // =========================
    // const fetchKelasByLevel = useCallback(
    //   async (gradeLevelId, schoolId, branchId) => {
    //     initKelasDone.current = false;

    //     if (!gradeLevelId) return;

    //     setLoadingKelas(true);
    //     try {
    //       const res = await APIMS.get(
    //         `/api/kelas?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
    //         fetchParams
    //       );

    //       if (res?.status === 200) {
    //         let kelas = res.data?.data || [];

    //         kelas = kelas.filter((x) => x?.ysb_grade_level_id === gradeLevelId);
    //         if (schoolId) kelas = kelas.filter((x) => x?.ysb_school_id === schoolId);
    //         if (branchId) kelas = kelas.filter((x) => x?.ysb_branch_id === branchId);

    //         kelas = sortKelas(kelas);
    //         setGetDataKelas(kelas);

    //         // default kelas pertama
    //         if (kelas.length > 0) {
    //           setForm2((prev) => ({
    //             ...prev,
    //             ysb_kelas_id: kelas[0].id,
    //           }));
    //         } else {
    //           setForm2((prev) => ({ ...prev, ysb_kelas_id: "" }));
    //         }
    //       }
    //     } catch (err) {
    //       console.error(err);
    //       swal({
    //         title: "Failed",
    //         text: err?.response?.data?.message || err.message || "Gagal mengambil data kelas",
    //         icon: "error",
    //         timer: 3000,
    //         buttons: false,
    //       });
    //       setGetDataKelas([]);
    //       setForm2((prev) => ({ ...prev, ysb_kelas_id: "" }));
    //     } finally {
    //       initKelasDone.current = true;
    //       setLoadingKelas(false);
    //     }
    //   }, [fetchParams]
    // );

    // useEffect(() => {
    //   if (!form2.ysb_grade_level_id) {
    //     setGetDataKelas([]);
    //     setForm2((prev) => ({ ...prev, ysb_kelas_id: "" }));
    //     return;
    //   }

    //   setGetDataKelas([]);
    //   setForm2((prev) => ({ ...prev, ysb_kelas_id: "" }));
    //   fetchKelasByLevel(form2.ysb_grade_level_id, form2.ysb_school_id, form2.ysb_branch_id);
    // }, [form2.ysb_grade_level_id, form2.ysb_school_id, form2.ysb_branch_id, fetchKelasByLevel]);

  
    // =========================
    // Filter complete
    // =========================
    const isFilterComplete =
      isFilterDirty &&
      !!form2.ysb_semester_id &&
      !!form2.ysb_branch_id &&
      !!form2.ysb_school_id ;
      // &&
      // (!loadingLevel && (getDataLevel.length === 0 || !!form2.ysb_grade_level_id)) &&
      // (!loadingKelas && (getDataKelas.length === 0 || !!form2.ysb_kelas_id));


  // =========================
  // Fetch table data
  // =========================
  const GetResponseData = useCallback(async () => {
    setSearchKeyword("");

    if (
      !form2.ysb_semester_id ||
      !form2.ysb_branch_id ||
      !form2.ysb_school_id 
    ) return;
    
    setIsFetching(true);

    const params = {
        ysb_semester_id: form2.ysb_semester_id,
        level: storageLevel,
        ysb_branch_id: form2.ysb_branch_id,
        ysb_school_id: form2.ysb_school_id,
      };

    //   if (form2.ysb_grade_level_id) {
    //     params.ysb_grade_level_id = form2.ysb_grade_level_id;
    //   }
    //   if (form2.ysb_kelas_id) {
    //     params.ysb_kelas_id = form2.ysb_kelas_id;
    // }

    try {
      const response = await APISD.post(
        `/api/absen-logs-admin?page=1&limit=1000&ascending=${ascdng}&search=`,
        fetchParams
      );

      if (response?.status === 200) {
        setGetData(response?.data?.data || []);
      }
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title: error.response?.data?.message || "Gagal memuat data",
      });
    } finally {
      setIsFetching(false);
    }
    }, [form2, fetchParams, ascending, storageLevel]);

  // useEffect(() => {
  //   GetResponseData();
  // }, [GetResponseData]);


  // AUTO LOAD
    useEffect(() => {
      const schoolReady =
        initSchoolDone.current &&
        !loadingSchool &&
        !!form2.ysb_school_id;

      // const gradeReady =
      //   initLevelDone.current &&
      //   !loadingLevel &&
      //   (getDataLevel.length === 0 || !!form2.ysb_grade_level_id);

      // const kelasReady =
      //   initKelasDone.current &&
      //   !loadingKelas &&
      //   (getDataKelas.length === 0 || !!form2.ysb_kelas_id);

      if (
        firstLoadDone.current ||
        !form2.ysb_semester_id ||
        !form2.ysb_branch_id ||
        !schoolReady 
        // ||
        // !gradeReady ||
        // !kelasReady
      ) return;

      firstLoadDone.current = true;

      (async () => {
        setIsFetching(true);
        await GetResponseData(); 
        setHasSearched(true);
        setIsFirstLoad(false);
        setIsFilterDirty(false);
        setIsFetching(false);
      })();
    }, [
      form2.ysb_semester_id,
      form2.ysb_branch_id,
      form2.ysb_school_id,
      // form2.ysb_grade_level_id,
      // form2.ysb_kelas_id,
      loadingSchool,
      // loadingLevel,
      // loadingKelas,
      // getDataLevel.length,
      // getDataKelas.length,
    ]);


    // =========================
    // HANDLER perubahan filter 
    // =========================
    const handleChange = (e) => {
      const { name, value } = e.target;

      setForm2((prev) => ({ ...prev, [name]: value }));

      if (!isFirstLoad) {
        setIsFilterDirty(true);
        setHasSearched(false);
      }
    };

    // =========================
    // BUTTON CARI
    // =========================
    const handleCari = async () => {
      
      // if (loadingSchool || loadingLevel || loadingKelas) {
      if (loadingSchool) {
        swal({
          title: "Mohon tunggu",
          text: "Data sekolah masih dimuat. Coba lagi sebentar.",
          icon: "info",
          timer: 2200,
          buttons: false,
        });
        return;
      }

      // const gradeRequired = getDataLevel.length === 0 ? true : !!form2.ysb_grade_level_id;
      // const kelasRequired = getDataKelas.length === 0 ? true : !!form2.ysb_kelas_id;

      // if (!form2.ysb_semester_id || !form2.ysb_branch_id || !form2.ysb_school_id || !gradeRequired || !kelasRequired) {
      if (!form2.ysb_semester_id || !form2.ysb_branch_id || !form2.ysb_school_id) {
        swal({
          title: "Filter belum lengkap",
          text: "Pastikan Semester, Cabang, Sekolah sudah dipilih.",
          icon: "warning",
        });
        return;
      }

      setGetData([]);
      setHasSearched(false);
      setIsFetching(true);
      setSearchKeyword("");

      try {
        await GetResponseData();
        setHasSearched(true);
        setIsFilterDirty(false);
      } catch (err) {
        swal({
          title: "Failed",
          text: err?.response?.data?.message || "Terjadi kesalahan",
          icon: "error",
        });
      } finally {
        setIsFetching(false);
      }
    };

  const nameCollator = useMemo(
    () => new Intl.Collator("id", { sensitivity: "base", numeric: true }),
    []
  );

  // =========================
  // FILTER SEARCH FRONTEND
  // =========================
  const filteredData = useMemo(() => {
    const q = (searchKeyword || "").trim().toLowerCase();

    const base = !q
      ? getData || []
      : (getData || []).filter((item) => {
          const label = (item?.stages || "").toString().toLowerCase();
          const namaJenjang = (item?.stages_name || "").toString().toLowerCase();

          return (
            label.includes(q) ||
            namaJenjang.includes(q) 
          );
        });

    return [...base].sort((a, b) =>
      nameCollator.compare(
        (a?.stages_name || "").toString().trim(),
        (b?.stages_name || "").toString().trim()
      )
    );
  }, [getData, searchKeyword, nameCollator]);

  // =========================
  // FRONTEND PAGINATION
  // =========================
  const totalRows = filteredData.length;

  const totalPages = useMemo(() => {
    const pages = Math.ceil(totalRows / Math.max(1, rowsPerPage));
    return pages <= 0 ? 1 : pages;
  }, [totalRows, rowsPerPage]);

  useEffect(() => {
    setTablePage(1);
  }, [searchKeyword, getData]);

  useEffect(() => {
    if (tablePage > totalPages) setTablePage(totalPages);
    if (tablePage < 1) setTablePage(1);
  }, [tablePage, totalPages]);

  const paginatedData = useMemo(() => {
    const safeRows = Math.max(1, rowsPerPage);
    const start = (tablePage - 1) * safeRows;
    return filteredData.slice(start, start + safeRows);
  }, [filteredData, tablePage, rowsPerPage]);

  const pageNumbers = useMemo(() => {
    const maxButtons = 5;
    const pages = [];

    if (totalPages <= maxButtons) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
      return pages;
    }

    const left = Math.max(1, tablePage - 1);
    const right = Math.min(totalPages, tablePage + 1);

    pages.push(1);
    if (left > 2) pages.push("...");
    for (let i = left; i <= right; i++) {
      if (i !== 1 && i !== totalPages) pages.push(i);
    }
    if (right < totalPages - 1) pages.push("...");
    pages.push(totalPages);

    return pages.filter((v, idx, arr) => arr.indexOf(v) === idx);
  }, [tablePage, totalPages]);

  const goToPage = (nextPage) => {
    const p = Math.min(Math.max(1, Number(nextPage) || 1), totalPages);
    setTablePage(p);
  };

  const toTitleCase = (value) => {
      const s = safeStr(value).toLowerCase().trim();
      if (!s) return "";
      return s.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1));
  };


  return (
    <div className="mt-4" >
      <style>{css}</style>
      <div >

            {/* FILTER */}
            {isTabletOrMobile ? (
              <div className="title-page">
                <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                  <select
                    className="mr-2"
                    name="ysb_semester_id"
                    value={form2.ysb_semester_id}
                    onChange={handleChange}
                    style={{
                      border: "1px solid #d9defa",
                      borderRadius: "12px",
                      fontSize: "14px",
                      padding: "10px 12px",
                      background: "#fff",
                    }}
                  >
                    <option value="" hidden>
                      {namaTA} (Semester {namaSmstr})
                    </option>
                    {getDataSemesterMap.map((user, index) => (
                      <option key={index} value={user?.id}>
                        {user?.name_year} (Semester {user?.semester})
                      </option>
                    ))}
                  </select>
                </Row>

                <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                  <select
                    className="mr-2"
                    name="ysb_branch_id"
                    value={form2.ysb_branch_id}
                    onChange={handleChange}
                      style={{
                      border: "1px solid #d9defa",
                      borderRadius: "12px",
                      fontSize: "14px",
                      padding: "10px 12px",
                      background: "#fff",
                    }}
                  >
                    <option value="" hidden>
                      Pilih Cabang
                    </option>
                    {getDataBranch.map((user, index) => (
                      <option key={index} value={user?.branch_code}>
                        {user?.branch_name}
                      </option>
                    ))}
                  </select>
                </Row>

                <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                  <select
                    className="mr-2"
                    name="ysb_school_id"
                    value={form2.ysb_school_id}
                    onChange={handleChange}
                     style={{
                      border: "1px solid #d9defa",
                      borderRadius: "12px",
                      fontSize: "14px",
                      padding: "10px 12px",
                      background: "#fff",
                    }}
                  >
                    <option value="" hidden>
                      Pilih Sekolah
                    </option>
                    {getDataSchool.map((user, index) => (
                      <option key={index} value={user?.school_code}>
                        {user?.school_name}
                      </option>
                    ))}
                  </select>
                </Row>

                <Row style={{ marginTop: "12px", padding: "0 12px" }}>
                  <button
                    onClick={handleCari}
                    disabled={!isFilterComplete}
                    className="btn"
                    style={{
                      fontSize: "13px",
                      padding: "10px 16px",
                      borderRadius: "12px",
                      backgroundColor: !isFilterComplete ? "#c9c9c9" : "#eca91aff",
                      color: "#fff",
                      cursor: !isFilterComplete ? "not-allowed" : "pointer",
                    }}
                  >
                    Cari
                  </button>
                </Row>
              </div>
            ) : (
              <>
                <div className="mb-3">
                  {loading ? (
                    <>
                      <div className="mb-3 d-flex">
                        <div className="shimmer shimmer-select mr-2" style={{width:180, borderRadius: "12px"}} />
                        <div className="shimmer shimmer-select mr-2" style={{width:220, borderRadius: "12px"}} />
                        <div className="shimmer shimmer-select mr-2" style={{width:220, borderRadius: "12px"}} />
                        <div className="shimmer shimmer-select mr-2" style={{width:60, borderRadius: "12px"}} />
                      </div>
                      
                    </>
                  ) : (
                      <div className="mb-3 mt-1">
                        <div className="d-flex">
                          <select
                            className="mr-2"
                            name="ysb_semester_id"
                            value={form2.ysb_semester_id}
                            onChange={handleChange}
                            style={{
                              border: "1px solid #d9defa",
                              borderRadius: "12px",
                              fontSize: "14px",
                              padding: "10px 12px",
                              background: "#fff",
                            }}
                          >
                            <option value="" hidden>
                              {namaTA} (Semester {namaSmstr})
                            </option>
                            {getDataSemesterMap.map((user, index) => (
                              <option key={index} value={user?.id}>
                                {user?.name_year} (Semester {user?.semester})
                              </option>
                            ))}
                          </select>

                          <select
                            className="mr-2"
                            name="ysb_branch_id"
                            value={form2.ysb_branch_id}
                            onChange={handleChange}
                            style={{
                              border: "1px solid #d9defa",
                              borderRadius: "12px",
                              fontSize: "14px",
                              padding: "10px 12px",
                              background: "#fff",
                            }}
                          >
                            <option value="" hidden>
                              Pilih Cabang
                            </option>
                            {getDataBranch.map((user, index) => (
                              <option key={index} value={user?.branch_code}>
                                {user?.branch_name}
                              </option>
                            ))}
                          </select>

                          <select
                            className="mr-2"
                            name="ysb_school_id"
                            value={form2.ysb_school_id}
                            onChange={handleChange}
                            disabled={loadingSchool}
                            style={{
                              border: "1px solid #d9defa",
                              borderRadius: "12px",
                              fontSize: "14px",
                              padding: "10px 12px",
                              backgroundColor: loadingSchool ? "#f5f5f5" : "#fff",
                              cursor: loadingSchool ? "not-allowed" : "pointer",
                            }}
                          >
                            <option value="" hidden> 
                              {loadingSchool ? "Memuat data sekolah..." : "Pilih Sekolah"}
                            </option>

                            {!loadingSchool &&
                              getDataSchool.map((user, index) => (
                                <option key={index} value={user?.school_code}>
                                  {user?.school_name}
                                </option>
                              ))}
                          </select>

                          <button
                            onClick={handleCari}
                            disabled={!isFilterComplete}
                            className="btn"
                            style={{
                              fontSize: "13px",
                              padding: "10px 16px",
                              borderRadius: "12px",
                              backgroundColor: !isFilterComplete ? "#c9c9c9" : "#eca91aff",
                              color: "#fff",
                              cursor: !isFilterComplete ? "not-allowed" : "pointer",
                              
                            }}
                          >
                            Cari
                          </button>
                        </div>

                      </div>
                  )
                }
                </div>
                
              </>           
            )}

        {isFetching && (
          <div className="text-center" style={{ padding: "10px 0" }}>
            <span style={{ color: "#2e52aeff", fontWeight: "500" }}>
              <PulseLoader color={"#3f5bea"} size={12} />
            </span>
          </div>
        )}
        
        
        {hasSearched && !isFetching && (
          <>
            <div className="mt-1">
              <div className="at-search">
                <input
                  className="at-input"
                  placeholder="Cari Log Absensi"
                  value={searchKeyword}
                  onChange={(e) => setSearchKeyword(e.target.value)}
                />
              </div>
            </div>

            {/* TABLE */}
            <Col xl='12' sm='12'> 
              <div className="mt-3">
                <div className="body-table" >
                  <div >
                    <table className="table dt-responsive nowrap w-100" id="basic-datatable">
                      <thead>
                        <tr>
                          <th>No</th>
                          <th>Nama Siswa</th>
                          <th>Tanggal</th>
                          <th>Jam</th>
                          <th>Sekolah</th>
                          <th>Cabang</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedData.length > 0 ? (
                          paginatedData.map((row, index) => (
                            <tr key={row?.id || index}>
                              <td style={{ lineHeight: "2" }}>
                                {(tablePage - 1) * rowsPerPage + (index + 1)}
                              </td>
                              <td style={{ lineHeight: "2" }}>
                                {row.name_student}
                              </td>
                              <td style={{ lineHeight: "2" }}>
                                {row.att_date}
                              </td>
                              <td style={{ lineHeight: "2" }}>
                                {row.att_time}
                              </td>
                              <td style={{ lineHeight: "2" }}>
                                {row.name_school}
                              </td>
                              <td style={{ lineHeight: "2" }}>
                                {row.name_branch}
                              </td>
                              
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="6" className="text-center" style={{ padding: "20px" }}>
                              Data tidak ditemukan
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    {filteredData.length > 0 && (
                      <div className="at-pagination">
                        <div
                          className="d-flex"
                          style={{ gap: 8, alignItems: "center" }}
                        >
                          <span className="at-page-info">
                            Menampilkan <b>{Math.min((tablePage - 1) * rowsPerPage + 1, totalRows)}</b>-
                            <b>{Math.min(tablePage * rowsPerPage, totalRows)}</b> dari <b>{totalRows}</b> data
                          </span>

                          <select
                            className="at-page-size"
                            value={rowsPerPage}
                            onChange={(e) => {
                              const v = Number(e.target.value) || 10;
                              setRowsPerPage(v);
                              setTablePage(1);
                            }}
                          >
                            <option value={10}>10 / halaman</option>
                            <option value={25}>25 / halaman</option>
                            <option value={50}>50 / halaman</option>
                            <option value={100}>100 / halaman</option>
                          </select>
                        </div>

                        <div
                          className="d-flex"
                          style={{ gap: 8, alignItems: "center" }}
                        >
                          <button
                            className="at-page-btn"
                            onClick={() => goToPage(tablePage - 1)}
                            disabled={tablePage <= 1}
                          >
                            Prev
                          </button>

                          <div className="at-page-numbers">
                            {pageNumbers.map((p, idx) =>
                              p === "..." ? (
                                <span
                                  key={`dots-${idx}`}
                                  className="at-page-info"
                                  style={{ padding: "0 6px" }}
                                >
                                  ...
                                </span>
                              ) : (
                                <button
                                  key={`page-${p}`}
                                  className={`at-page-number ${
                                    p === tablePage ? "active" : ""
                                  }`}
                                  onClick={() => goToPage(p)}
                                >
                                  {p}
                                </button>
                              )
                            )}
                          </div>

                          <button
                            className="at-page-btn"
                            onClick={() => goToPage(tablePage + 1)}
                            disabled={tablePage >= totalPages}
                          >
                            Next
                          </button>
                        </div>
                      </div>
                    )}

                  </div>
                </div>
              </div>
            </Col>
          </>
        )}  
        
      </div>
    </div>
   );



}
